import { useState } from "react";
import "./style.css"
import { RiCheckLine, RiCloseLine } from "react-icons/ri";
import { useMutation } from "@apollo/client";
import { CHECK_MAIL } from "../graphql/mutation";

export default function SystemCheck() {

  const [website, setWebsite] = useState(null)
  const [server, setServer] = useState(null)
  const [mail, setMail] = useState(null)
  const [loading, setLoading] = useState(false)

  const [check] = useMutation(CHECK_MAIL)

  async function isWebsiteReachable(url) {
    try {
      await fetch(url, {
        method: 'HEAD',
        mode: 'no-cors'
      });
      return "Done";
    } catch (error) {
      return "Error";
    }
  }

  const start = async () => {
    try {
      setLoading(true)
      await isWebsiteReachable("https://www.thisischartering.com").then((e) => {
        if (e) {
          setWebsite(e)
        }
      })
      await isWebsiteReachable("https://chartering.mykeystone.in").then((e) => {
        if (e) {
          setServer(e)
        }
      })
      console.log(process.env.REACT_APP_BREVO);

      check().then((e) => {
        if (e?.data?.checkMail) {
          setMail(e?.data?.checkMail)
        }
      })
    } catch (error) {
      alert("Status Check Failed")
    }
  }

  return (
    <div className='SystemCheck'>
      <div className="SystemCheckHead">
        SYSTEM CHECK
      </div>
      {!loading ?
        <button onClick={() => start()} className="SystemCheckBtn">Start system check</button>
        :
        <div className="SystemCheckCon">
          <div className="SystemCheckCon1">
            {website === "Done" ?
              <div className="SystemCheckCircleGreen">
                <RiCheckLine color="#fff" size={20} />
              </div>
              : website === "Error" ?
                <div className="SystemCheckCircleRed">
                  <RiCloseLine color="#fff" size={20} />
                </div>
                :
                <div className="SystemCheckCircle">
                  <div className="SystemCheckCircleLoad" />
                </div>}
            <p>{website === "Done" ? "Website Is Working" : website === "Error" ? "Website Is Not Working" : "Checking Website Status"}</p>
          </div>
          <div className="SystemCheckCon1">
            {server === "Done" ?
              <div className="SystemCheckCircleGreen">
                <RiCheckLine color="#fff" size={20} />
              </div>
              : server === "Error" ?
                <div className="SystemCheckCircleRed">
                  <RiCloseLine color="#fff" size={20} />
                </div>
                :
                <div className="SystemCheckCircle">
                  <div className="SystemCheckCircleLoad" />
                </div>}
            <p>{server === "Done" ? "Server Is Working" : server === "Error" ? "Server Is Not Working" : "Checking Server Status"}</p>
          </div>
          <div className="SystemCheckCon1">
            {mail === "Done" ?
              <div className="SystemCheckCircleGreen">
                <RiCheckLine color="#fff" size={20} />
              </div>
              : mail === "Error" ?
                <div className="SystemCheckCircleRed">
                  <RiCloseLine color="#fff" size={20} />
                </div>
                :
                <div className="SystemCheckCircle">
                  <div className="SystemCheckCircleLoad" />
                </div>}
            <p>{mail === "Done" ? "Mail Is Working" : mail === "Error" ? "Mail Is Not Working" : "Checking Mail Status"}</p>
          </div>
        </div>
      }
    </div>
  )
}
